
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import StepperComponent from "slotworks/components/ui/stepper-component";

/**
 * Attempts to set a specified totalStake value on an options object.
 * If the stepper value matches this value, call resolve
 * If the stepper value does not match, increase it or decrease it (towards the target) and call reject, passing in the new stepper value
 * Use this to recursively increase or decrease the total stepper until a valid value is reached
 */
export function FindValidTotalStake(totalStake: number, options: BetOptions, totalStakeStepper: StepperComponent, reject: (value: number) => void, resolve: Function) {
    // TODO: Uncomment the below line to have the coin size lock during coin mode - needs some thought as to how to configure this
    // options.setTotalStake(totalStake, Currency.credits);
    options.setTotalStake(totalStake);

    const targetStakeReached = options.getTotalStake() === totalStake;
    const totalStepperAtLimit = totalStakeStepper.isAtALimit();

    if (!targetStakeReached && !totalStepperAtLimit) {
        if (options.getTotalStake() < totalStake) {
            totalStakeStepper.increase();
        } else {
            totalStakeStepper.decrease();
        }
        reject(totalStakeStepper.getSelectedValue());
    } else {
        resolve();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/betbar-helpers.ts